export default {
  withdrawal_address_placeholder: 'Please enter your withdrawal address',
  withdrawal_amount_maximum: 'The withdrawal amount must not exceed the maximum withdrawal amount of {num}',
  withdrawal_amount_minimum: 'The withdrawal amount must not fall below the minimum withdrawal amount of {num}',
  withdrawal_amount_balance: 'The withdrawal amount must not exceed the balance',
  memo_placeholder: 'Please enter Memo',
  fund_password_placeholder: 'Please enter fund password',
  fund_password_incorrect: 'Incorrect format of Fund Password',
  phone_code_placeholder: 'Please enter your phone verification code',
  code_incorrect: 'Incorrect format of verification code',
  email_code_placeholder: 'Please enter your email verification code',
  google_code_placeholder: 'Please enter the Google Authenticator verification code',
  withdrawal_amount_placeholder: 'Please enter withdrawal amount',
  enter_email: "Please enter your email address",
  enter_phone: "Please enter your phone number",
  enter_new_phone: "Please enter new phone number",
  enter_new_fund_password: "Please enter new fund password",
  enter_new_email: "Please enter new email address",
  enter_password:	"Please enter password",
  enter_new_password:	"Please enter new password",
  enter_fund_password: "Please enter 6 digits number password",
  invalid_email: "Invalid email format",
  amount_placeholder: 'Please enter the amount'
};
